export default () => (Math.random().toString(16) + '000000000').substr(2, 10);
